export const SITE_NAME_LONG = "Celeste Stats";
export const CURRENT_VERSION = {
  major: 1,
  minor: 0,
  patch: 5,
  asString: () => `${CURRENT_VERSION.major}.${CURRENT_VERSION.minor}.${CURRENT_VERSION.patch}`,
};
